require('./brokerOrdersAndMovementsActivityTableRow.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classNames = require('classnames');

// @ helpers
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { isCurrentYear, formatDate } = require('utilities/dateHelper');
// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTag = require('components/commons/OKTag/OKTag');
const { formatText, getLanguage } = require('core/i18n').i18n;
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');
//@constants
const {
    BROKER_JOINT_CONTRACTS_VALUE,
    BROKER_JOINT_CONTRACTS_FUND,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_DEFAULT_LAST_DATE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    DATE_FORMAT_DAY_MONTH,
    DATE_FORMAT,
    HYPHEN
} = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
const BrokerOrdersAndMovementsCancelContractButton = require('components/broker/brokerOrdersAndMovementsCancelContractButton/brokerOrdersAndMovementsCancelContractButton');
// @actions
const brokerOrderCancelActions = require('actions/brokerOrderCancel');
const brokerFundOrderCancelActions = require('actions/brokerFundOrderCancel');
const brokerCancelMovementActions = require('actions/contactCenter/brokerCancelMovement')

const CANCELLABLE_STATES = ['PENDIENTE', 'EJECUTADA PARCIALMENTE', 'NO ENVIAD'];
const language = getLanguage();

class BrokerOrdersAndMovementsActivityTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnRowClick = this.handleOnRowClick.bind(this);
        this.onRowClick = this.handleOnRowClick.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildValueRow = this.buildValueRow.bind(this);
        this.buildFundRow = this.buildFundRow.bind(this);
        this.buildPlanOtherRow = this.buildPlanOtherRow.bind(this);
        this.buildPlanPeriodicRow = this.buildPlanPeriodicRow.bind(this);
        this.buildFundsLabelDate = this.buildFundsLabelDate.bind(this);
    }

    handleOnRowClick() {
        const { id, onRowClick } = this.props;
        
        onRowClick(id);
    }

    buildFundsLabelDate(date){
        let formattedDate;
        let content;

        if(date){
            if (isCurrentYear(date)) {
                formattedDate = formatDate(date, DATE_FORMAT_DAY_MONTH);
                content = <span className="label-date">{formattedDate}</span>;
            } else {
                formattedDate = formatDate(date, DATE_FORMAT);
                content = <span className="label-date">{formattedDate}</span>;
            }

        } else {
            content = "-";
        }

        return content;
    }

    buildFixArrowButton() {
        return(
            <div className="broker-orders-and-movements-activity-table-row__cell-arrow-fix-position-icon">
                <OKCollapsingToggler
                    handlerToggle={this.onRowClick}
                    isExpanded={this.props.isExpanded}
                    isIconFixed
                    isIconSecondary
                />
            </div>
        );
    }

    buildValueRow() {
        const {
            immTransaction,
            immOrderCancel,
            id,
            originalIndex,
            isExpanded,
            isSignaturePatternLoading,
            clearCancelAnOrderData,
            openMovementCancelationModal,
            requestCancelAnOrder
        } = this.props;

        const movementValueClass = classNames({
            'broker-orders-and-movements-activity-table-row__cell-value--expanded': isExpanded
        });

        const rawState = immTransaction.get('rawState');
        const isInMarket = CANCELLABLE_STATES.indexOf(rawState) !== -1;
        const cancelCellClasses = classNames(
            'broker-orders-and-movements-activity-table-row__cell-cancel',
            {
                'broker-orders-and-movements-activity-table-row__cell-cancel-empty':
                    !isInMarket && originalIndex !== 0
            }
        );
        const type = toFirstUppercase(immTransaction.get('type'));
        let cancelButton;
        let modifier = 'informative';
        if (isInMarket) {
            modifier = 'pending';
            cancelButton = (
                <BrokerOrdersAndMovementsCancelContractButton
                    originalIndex={originalIndex}
                    immTransaction={immTransaction}
                    immOrderCancel={immOrderCancel}
                    isSignaturePatternLoading={isSignaturePatternLoading}
                    clearCancelAnOrderData={clearCancelAnOrderData}
                    requestCancelAnOrder={requestCancelAnOrder}
                    largeConfirmationModal={true}
                    openMovementCancelationModal={openMovementCancelationModal}
                />
            );
        }
        else {
            cancelButton = (
                <div className="broker-orders-and-movements-activity-table-row__button-placeholder" />
            );
        }

        const toggleArrowButton = this.buildFixArrowButton();

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" key={id}>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-arrow">
                    {toggleArrowButton}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    <div className="broker-orders-and-movements-activity-table-row__container-date">
                        <LabelDate
                            date={immTransaction.get('date')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </div>
                </OKTableCell>
                <OKTableCell>
                    <div className={movementValueClass}>
                        <div>
                            {immTransaction.get('number')}
                        </div>
                    </div>
                </OKTableCell>
                <OKTableCell>
                    <div className="broker-orders-and-movements-activity__cell-description">
                        <div>
                            {immTransaction.get('description')}
                        </div>
                    </div>
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-type">
                    {type}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-state">
                    <OKTag content={immTransaction.get('state')} type={modifier}  context="arrow"/>
                </OKTableCell>
                <OKTableCell className={cancelCellClasses}>
                    {cancelButton}
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildFundRow() {
        const {
            immTransaction,
            immFundOrderCancel,
            id,
            originalIndex,
            isExpanded,
            isSignaturePatternLoading,
            clearCancelAFundOrderData,
            openMovementCancelationModal,
            requestCancelAFundOrder
        } = this.props;
        const expandedOparationClass = classNames({
            'broker-orders-and-movements-activity-table-row__expanded-accordion': isExpanded
        });
        const cancellable = immTransaction.get('state') === BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING && immTransaction.get('annullable');
        let cancelButton;
        const operationKey = `fundsOrdersandMovementsOperationCode-${immTransaction.get('operationCode')}`;
        const operationText = formatText(operationKey);
        const operationFundName = operationText !== '####' ? operationText : '-';
        const plainAmountObject = getPlainAmountObject(immTransaction.get('import'));

        if (cancellable) {
            cancelButton = (
                <BrokerOrdersAndMovementsCancelContractButton
                    originalIndex={originalIndex}
                    immTransaction={immTransaction}
                    immOrderCancel={immFundOrderCancel}
                    isSignaturePatternLoading={isSignaturePatternLoading}
                    clearCancelAnOrderData={clearCancelAFundOrderData}
                    requestCancelAnOrder={requestCancelAFundOrder}
                    largeConfirmationModal={false}
                    openMovementCancelationModal={openMovementCancelationModal}
                />
            );
        } else {
            cancelButton = (
                <div className="broker-orders-and-movements-activity-table-row__button-placeholder" />
            );
        }

        const LabelDateRequested = this.buildFundsLabelDate(immTransaction.get('dateRequested'));
        const LabelDateValue = this.buildFundsLabelDate(immTransaction.get('dateValue'));
        const toggleArrowButton = this.buildFixArrowButton();

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" id={id}>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-arrow">
                    {toggleArrowButton}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    {LabelDateRequested}
                </OKTableCell>
                <OKTableCell>
                    <div className={expandedOparationClass}>
                        {operationFundName}
                    </div>
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell>
                    {LabelDateValue}
                </OKTableCell>
                <OKTableCell>
                    {cancelButton}
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildPlanOtherRow() {
        const { immTransaction, id } = this.props;
        // TODO: Remove this logic when importeDelMovimiento data come in number format from API
        let amountObject;

        if (typeof immTransaction.getIn(['import', 'amount']) === 'string') {
            amountObject = {
                amount: parseFloat(
                    immTransaction.getIn(['import', 'amount']).replace('.', '').replace(',', '.')
                ),
                currency: immTransaction.getIn(['import', 'currency'])
            };
        } else {
            amountObject = immTransaction.get('import');
        }

        const plainAmountObject = getPlainAmountObject(amountObject);
        const operationText = formatText(`plansOrdersAndMovementsOperationType-${immTransaction.get('operationCode')}`);

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" id={id}>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    <LabelDate
                        date={immTransaction.get('date')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    {operationText}
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-state">
                    {immTransaction.get('state')}
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildPlanExtraordinaryRow() {
        const { immTransaction, id } = this.props;
        // TODO: Remove this logic when importeDelMovimiento data come in number format from API
        let amountObject;

        if (typeof immTransaction.getIn(['import', 'amount']) === 'string') {
            amountObject = {
                amount: parseFloat(
                    immTransaction.getIn(['import', 'amount']).replace('.', '').replace(',', '.')
                ),
                currency: immTransaction.getIn(['import', 'currency'])
            };
        } else {
            amountObject = immTransaction.get('import');
        }
        const plainAmountObject = getPlainAmountObject(amountObject);

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" id={id}>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    <LabelDate
                        date={immTransaction.get('date')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('operation')}
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-state">
                    {immTransaction.get('state')}
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildPlanPeriodicRow() {
        const { immTransaction, id, originalIndex, isExpanded } = this.props;
        const periodicityLabel = toFirstUppercase(immTransaction.get('periodicityText'));
        const expandIconClass = classNames({
            'icon-accordion-abrir': !isExpanded,
            'icon-accordion-cerrar': isExpanded
        });
        const plainAmountObject = getPlainAmountObject(immTransaction.get('import'));
        let lastContributionDate;
        let nextContributionDate;

        if (immTransaction.get('dateLast') !== BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_DEFAULT_LAST_DATE) {
            lastContributionDate = (<LabelDate
                date={immTransaction.get('dateLast')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />)
        } else {
            lastContributionDate = HYPHEN;
        }

        if (immTransaction.get('dateNext') !== BROKER_ORDERS_AND_MOVEMENTS_PLAN_CONTRIBUTION_NO_NEXT_DATE) {
            nextContributionDate = (<LabelDate
                date={immTransaction.get('dateNext')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />)
        } else {
            nextContributionDate = HYPHEN
        }

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" id={id}>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-arrow">
                    <button
                        className="broker-orders-and-movements-activity-table-row__button-collapse"
                        onClick={this.handleOnRowClick}
                        id={`btnContractActivityToggle${originalIndex}`}
                    >
                        <i className={expandIconClass} />
                    </button>
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    <LabelDate
                        date={immTransaction.get('date')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    {periodicityLabel}
                </OKTableCell>
                <OKTableCell>
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    {lastContributionDate}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-date">
                    {nextContributionDate}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-state">
                    <OKTag content={immTransaction.get('state')} context="arrow" />
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildPlanPendingMoves() {
        const { immTransaction, originalIndex, isExpanded, id } = this.props;

        const expandIconClass = classNames({
            'icon-accordion-abrir': !isExpanded,
            'icon-accordion-cerrar': isExpanded,
        });

        return (
            <OKTableRow className="broker-orders-and-movements-activity-table-row" id={id}>
                <OKTableCell>
                    <button
                        className="broker-orders-and-movements-activity-table-row__button-collapse"
                        onClick={this.handleOnRowClick}
                        id={`btnContractActivityToggle${originalIndex}`}
                    >
                        <i className={expandIconClass} />
                    </button>
                </OKTableCell>
                <OKTableCell>
                    {immTransaction.get('operation')}
                </OKTableCell>
                <OKTableCell className="broker-orders-and-movements-activity-table-row__cell-state">
                    {immTransaction.get('operationsCount')}
                </OKTableCell>
            </OKTableRow>
        );
    }

    render() {
        const { immTransaction } = this.props;
        let content;

        switch (immTransaction.get('movementType')) {
            case BROKER_JOINT_CONTRACTS_VALUE:
                content = this.buildValueRow();
                break;
            case BROKER_JOINT_CONTRACTS_FUND:
                content = this.buildFundRow();
                break;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC:
                content = this.buildPlanPeriodicRow();
                break;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER:
                content = this.buildPlanOtherRow();
                break;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_EXTRAORDINARY:
                content = this.buildPlanExtraordinaryRow();
                break;
            case BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES:
                content = this.buildPlanPendingMoves();
                break;
        }

        return content;
    }
}

BrokerOrdersAndMovementsActivityTableRow.propTypes = {
    immTransaction: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    originalIndex: PropTypes.number.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onRowClick: PropTypes.func.isRequired,
    isSignaturePatternLoading: PropTypes.bool.isRequired,
    immOrderCancel: PropTypes.object.isRequired,
    immFundOrderCancel: PropTypes.object.isRequired,
    clearCancelAFundOrderData: PropTypes.func.isRequired,
    requestCancelAFundOrder: PropTypes.func.isRequired,
    clearCancelAnOrderData: PropTypes.func.isRequired,
    openMovementCancelationModal: PropTypes.func.isRequired,
    requestCancelAnOrder: PropTypes.func.isRequired
};

module.exports.constructor = BrokerOrdersAndMovementsActivityTableRow;

module.exports.BrokerOrdersAndMovementsActivityTableRow = connect(
    state => ({
        immOrderCancel: state.brokerOrderCancel,
        isSignaturePatternLoading: state.signaturePattern.get('isFetchingConfig'),
        immFundOrderCancel: state.brokerFundOrderCancel
    }),
    {
        clearCancelAFundOrderData: brokerFundOrderCancelActions.clearCancelAnOrderData,
        requestCancelAFundOrder: brokerFundOrderCancelActions.requestCancelAnOrder,
        clearCancelAnOrderData: brokerOrderCancelActions.clearCancelAnOrderData,
        openMovementCancelationModal: brokerCancelMovementActions.openMovementCancelationModal,
        requestCancelAnOrder: brokerOrderCancelActions.requestCancelAnOrder
    }
)(BrokerOrdersAndMovementsActivityTableRow);
